import { DefaultInputPropTypes, EnumDropdown } from 'framework/form';
import { WASTE_TYPE_OPTIONS } from 'domain/shared/waste';

const WasteTypeDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={WASTE_TYPE_OPTIONS} label="Type" {...props} />;
};

export default WasteTypeDropdown;
